var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquare4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 72,
    viewBox: "0 0 78 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75545 9.44123C1.96076 7.46096 3.60568 5.96001 5.59583 5.90617L39.0954 5L72.5589 5.9052C74.5647 5.95945 76.2173 7.48316 76.4056 9.4808C76.9616 15.3791 78 27.5011 78 35.7639C78 44.0469 76.9565 56.1931 76.4016 62.0672C76.2148 64.0441 74.5926 65.5597 72.6085 65.6402L39.0954 67L5.54662 65.6387C3.57812 65.5589 1.9635 64.0658 1.75987 62.1062C1.1512 56.2488 0 44.0722 0 35.7639C0 27.4757 1.14565 15.3229 1.75545 9.44123Z",
    fill: "#A098AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3C49 3 53.9799 2 57.5 2C61.0201 2 66 3 66 3",
    stroke: "#F58634",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69C66 69 61.0201 70 57.5 70C53.9799 70 49 69 49 69",
    stroke: "#F58634",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3C15 3 19.9799 2 23.5 2C27.0201 2 32 3 32 3",
    stroke: "#F58634",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69C32 69 27.0201 70 23.5 70C19.9799 70 15 69 15 69",
    stroke: "#F58634",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare4);
export default __webpack_public_path__ + "static/media/square4.44ba5835ea0e122a18b6c9524e702973.svg";
export { ForwardRef as ReactComponent };